var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdOther({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    id: "svg_1"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FAFBD1",
    height: 24,
    id: "svg_2",
    rx: 2,
    transform: "matrix(1 0 0 1 0 0)",
    width: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12,17.03a4.98,4.98 0 0 0 3.72,-1.66a5,5 0 1 0 -3.72,1.66z",
    fill: "#000000",
    id: "svg_4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdOther);
export default __webpack_public_path__ + "static/media/icon-pd-other.3a79fdc7395ac84191cca066f1a44751.svg";
export { ForwardRef as ReactComponent };